// Static ISO-3166-1 alpha-2 country list for the persona "Market region"
// select. No dependency - the suggest endpoint returns an alpha-2 code
// (`market_region`), which we map to a display name here. Codes that aren't in
// this list (rare) are handled gracefully by CountrySelect, which appends the
// raw code as its own option so a suggested value is never silently dropped.

export interface Country {
  code: string; // ISO-3166-1 alpha-2
  name: string;
}

/** Common markets first (English-speaking, then major economies), then the
 *  rest A–Z. Curated rather than exhaustive; CountrySelect tolerates unknowns. */
export const COUNTRIES: Country[] = [
  { code: "US", name: "United States" },
  { code: "GB", name: "United Kingdom" },
  { code: "CA", name: "Canada" },
  { code: "AU", name: "Australia" },
  { code: "IE", name: "Ireland" },
  { code: "NZ", name: "New Zealand" },
  { code: "AT", name: "Austria" },
  { code: "BE", name: "Belgium" },
  { code: "BR", name: "Brazil" },
  { code: "CH", name: "Switzerland" },
  { code: "CN", name: "China" },
  { code: "CZ", name: "Czechia" },
  { code: "DE", name: "Germany" },
  { code: "DK", name: "Denmark" },
  { code: "ES", name: "Spain" },
  { code: "FI", name: "Finland" },
  { code: "FR", name: "France" },
  { code: "HK", name: "Hong Kong" },
  { code: "IN", name: "India" },
  { code: "IT", name: "Italy" },
  { code: "JP", name: "Japan" },
  { code: "MX", name: "Mexico" },
  { code: "NL", name: "Netherlands" },
  { code: "NO", name: "Norway" },
  { code: "PL", name: "Poland" },
  { code: "PT", name: "Portugal" },
  { code: "SE", name: "Sweden" },
  { code: "SG", name: "Singapore" },
  { code: "ZA", name: "South Africa" },
  { code: "AE", name: "United Arab Emirates" },
];

const BY_CODE = new Map(COUNTRIES.map((c) => [c.code, c]));

/** Display name for an alpha-2 code, falling back to the raw code. */
export function countryName(code: string | null | undefined): string {
  if (!code) return "";
  return BY_CODE.get(code.toUpperCase())?.name ?? code.toUpperCase();
}

/** True when the code is one we render by name (vs an unknown passthrough). */
export function isKnownCountry(code: string): boolean {
  return BY_CODE.has(code.toUpperCase());
}
